'use strict';

$(() => {
    $('.discover-categories__tiles-wrapper').each(function () {
        const $discoverCategoriesSlickRegion = $(this);
        const $discoverCategoriesContentWrapper = $(this).closest('.discover-categories__content-wrapper');
        const $discoverCategoriesTiles = $(this).find('.discover-categories-tiles');
        const $discoverCategoriesTilesWrapper = $('.discover-categories__tiles-wrapper');

        const $slickObj = {
            dots: false,
            arrows: true,
            infinite: false,
            speed: 1000,
            touchThreshold: 100,
            slidesToShow: 9,
            slidesToScroll: 1,

            responsive: [
                {
                    breakpoint: 1441,
                    settings: {
                        slidesToShow: 8.5,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1201,
                    settings: {
                        slidesToShow: 7.5,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 4.25,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2.25,
                        slidesToScroll: 1,
                        swipeToSlide: true,
                    },
                },
            ],
        };

        /**
         * Updates the state of the navigation arrows for the Slick carousel.
         *
         * Checks the current slide index, total slides, and slides-to-show settings
         * from the Slick carousel instance. Based on these values, the function
         * enables or disables the "previous" and "next" navigation arrows.
         *
         * @returns {void} No return value.
         *
         */
        function updateArrowState() {
            if (!$discoverCategoriesSlickRegion.hasClass('slick-initialized')) {
                return;
            }
            const $prevArrow = $discoverCategoriesContentWrapper.find('.slick-prev');
            const $nextArrow = $discoverCategoriesContentWrapper.find('.slick-next');
            const currentSlide = $discoverCategoriesSlickRegion.slick('getSlick').currentSlide;
            const totalSlides = $discoverCategoriesSlickRegion.slick('getSlick').slideCount;
            const slidesToShow = $discoverCategoriesSlickRegion.slick('getSlick').options.slidesToShow;
            // Disable prev arrow if on the first slide
            if (currentSlide === 0) {
                $prevArrow.addClass('disabled').attr('disabled', true);
            } else {
                $prevArrow.removeClass('disabled').attr('disabled', false);
            }

            // Disable next arrow if on the last visible slide
            if (currentSlide >= totalSlides - slidesToShow) {
                $nextArrow.addClass('disabled').attr('disabled', true);
            } else {
                $nextArrow.removeClass('disabled').attr('disabled', false);
            }

            if (currentSlide === 0 && currentSlide >= totalSlides - slidesToShow) {
                $prevArrow.hide();
                $nextArrow.hide();
            }
        }
        /**
         * Initializes the Slick carousel if it is not already initialized.
         *
         * This function sets up the Slick carousel on the `$discoverCategoriesSlickRegion` element
         * using the provided Slick configuration object (`$slickObj`). Once initialized, it ensures
         * that the previous and next navigation arrows are visible and calls the `updateArrowState`
         * function to set their initial states.
         *
         * @function initializeSlick
         * @returns {void}
         *
         */
        function initializeSlick() {
            if (!$discoverCategoriesSlickRegion.hasClass('slick-initialized')) {
                $discoverCategoriesSlickRegion.slick($slickObj);
                $discoverCategoriesContentWrapper.find('.slick-prev').removeClass('d-none');
                $discoverCategoriesContentWrapper.find('.slick-next').removeClass('d-none');
                updateArrowState();
            }
        }
        /**
         * Determines whether to initialize the Slick carousel based on the slide count and the current breakpoint.
         *
         * Checks the number of child elements (slides) in the `$discoverCategoriesSlickRegion` container
         * and initializes the Slick carousel (`initializeSlick`) only if the slide count exceeds the thresholds
         * for the current breakpoint:
         * - **Desktop (lg)**: Initialize if more than 9 slides.
         * - **Tablet (md)**: Initialize if more than 4 slides.
         * - **Mobile**: Initialize if more than 2 slides.
         *
         * @function initializeSlider
         * @returns {void}
         */
        function initializeSlider() {
            var slideCount = $discoverCategoriesSlickRegion.children().length;

            if (app.getCurrentDevice() === 'desktop') {
                // Desktop: Initialize slider if 9 or more slides
                if (slideCount > 8) {
                    initializeSlick();
                }
            } else if (app.getCurrentDevice() === 'tablet') {
                // Tablet: Initialize slider if 4 or more slides
                if (slideCount > 4) {
                    initializeSlick();
                }
            } else if (app.getCurrentDevice() === 'mobile') {
                // Mobile: Initialize slider if 2 or more slides
                if (slideCount > 2) {
                    initializeSlick();
                }
            }
        }

        // Call the function initially
        initializeSlider();

        $discoverCategoriesSlickRegion.on('init', function () {
            $discoverCategoriesContentWrapper.find('.slick-prev').removeClass('d-none');
            $discoverCategoriesContentWrapper.find('.slick-next').removeClass('d-none');
            updateArrowState();
        });

        $discoverCategoriesContentWrapper.on('click', '.slick-next', function () {
            $discoverCategoriesSlickRegion.slick('slickNext');
            if ($slickObj.slidesToShow === 8.5 && $discoverCategoriesTilesWrapper.find('.slick-slide').length === 9 && app.checkBreakPoint('lg')) {
                $discoverCategoriesTilesWrapper.slick('slickAdd', '<div class="slick-slide ghost-slide"></div>');
            }
            updateArrowState();
        });
        $discoverCategoriesContentWrapper.on('click', '.slick-prev', function () {
            $discoverCategoriesSlickRegion.slick('slickPrev');
            updateArrowState();
        });
        $discoverCategoriesSlickRegion.on('afterChange', function () {
            updateArrowState();
        });

        const currentUrl = window.location.href;
        $discoverCategoriesTiles.each(function () {
            if (this.href === currentUrl) {
                $discoverCategoriesTiles.removeClass('selected');
                $(this).addClass('selected');
            }

            if ($('.discover-categories-tiles').hasClass('filterselected')) {
                $('.discover-categories__tiles-wrapper.slick-initialized').addClass('filter-selected');
            }
        });
    });
});
